import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import axiosClient from '../constants';
import { Messages } from 'primereact/messages';
import { Link } from 'react-router-dom';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userName: '',
			password: '',
			licenseDialog: false,
			name: '',
			org: '',
			request: '',
			version: { version: null },
			badCreds: false,
			allTotals: { "totals": "", "customers": "" }
		};
	}

	componentDidMount() {
		localStorage.removeItem("userName");
		localStorage.removeItem("token");
		localStorage.removeItem("role");
		axiosClient.get("/config/version")
			.then(res => this.setState({ version: res.data }))
			.catch(error => {
				let msg = { severity: 'error', summary: 'Error occurred', detail: "Cannot access the App. Is the App running?" + error };
				this.messages.show(msg);
			});

		axiosClient.get("/config/all-totals")
			.then(res => this.setState({ allTotals: res.data }))
			.catch(error => {
				let msg = { severity: 'error', summary: 'Error occurred', detail: "Cannot access the App. Is the App running?" + error };
				this.messages.show(msg);
			});

	}

	updateLoginDateTime() {

		var today = new Date();
		var dateTime = today.getTime();

		axiosClient.put("/updateLastLogin", {
			"userId": this.state.userName,
			"lastloggedindatetime": dateTime
		})
	}

	render() {
		const login = (e) => {
			e.preventDefault();
			axiosClient.post("/login", {
				"userId": this.state.userName,
				"password": this.state.password
			}).then(res => {
				if (res !== undefined) {
					this.updateLoginDateTime();
					localStorage.removeItem("userName");
					localStorage.removeItem("token");
					localStorage.removeItem("role");
					localStorage.removeItem("permissions");
					localStorage.setItem("userName", res.data.userId);
					localStorage.setItem("token", res.data.token);
					localStorage.setItem("role", res.data.role);
					localStorage.setItem("permissions", res.data.permissions);
					if (res.data.role === 'ADMIN' || res.data.role === 'NORMAL-USER') {
						window.location.href = "/tax-reco/#"
					} else if (res.data.role === 'UTILITY-USER') {
						window.location.href = "/tax-reco/#/utilities"
					} else {
						window.location.href = "/tax-reco/#"
					}

				} else {
					let msg = { severity: 'error', summary: 'Login Failed: ', detail: "Invalid Credentials" };
					this.messages.show(msg);
				}
			}).catch(error => {
				let msg;
				if (error.response && (error.response.status === 401 || error.response.status === 403)) {
					msg = { severity: 'error', summary: 'Login Failed: ', detail: "Invalid Username or Password" };
				} else {
					msg = { severity: 'error', summary: 'Error occurred', detail: "Cannot access the App. Is the App running?" + error };
				}
				this.messages.show(msg);
			});
		}
		return <div className="login-body">
			<div className="card login-panel p-fluid">
				<div className="login-panel-content">
					<div className="p-grid">
						<div className="p-col-12" style={{ textAlign: 'left' }}>
							<img src="assets/layout/images/l.png" alt="login" />
						</div>
						<div className="p-col-12" style={{ textAlign: 'left' }}>
							<h2 className="welcome-text">Sign In</h2>
						</div>
						<form className="p-col-12" onSubmit={login}>

							<div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Username</label>
								<div className="login-input">
									<InputText placeholder="Username" value={this.state.userName} onChange={e => this.setState({ userName: e.target.value })} />
								</div>
							</div>
							<div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Password</label>
								<div className="login-input">
									<InputText type="password" placeholder="Password" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
								</div>
							</div>
							<Messages ref={(el) => this.messages = el} />

							<div className="p-col-12 p-md-12 button-pane">
								<Button
									type="submit"
									className="p-button-danger"
									label="Sign In" />
							</div>
						</form>

						<div className="p-col-12 p-md-12">
							<h3>Dont have an account? <Link to="/register" >Register</Link></h3>
							<br />
						</div>
						<div className="p-col-12 p-md-12">
							<Link to="/forgot-password" >Forgot Password?</Link>
							<br />
						</div>
						<div className="p-col-12 p-md-12">
							<span> Build version: {this.state.version.version}</span>
						</div>
						<div className="p-col-12 p-md-12">
							<br /><br />
						</div>
						<div className="p-col-12 p-md-12">
							<span>Reconciled &#8377; {(this.state.allTotals.totals / 10000000).toFixed(1) + " cr"} for {this.state.allTotals.customers} customers (and counting) so far.</span>
						</div>
						<div className="p-col-12 p-md-12">
							<br />
							<a style={{ color: "#fff" }} target='_blank' rel="noopener noreferrer" href="https://www.taxreco.com/"><div>Made with <span style={{ color: "#e25555" }}>&#9829;</span> by TaxReco Team</div></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}